import { SVGProps, Ref, forwardRef } from 'react';

export const ChartBarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5m-.702 11.497h1.4V3.999h-1.4zm-1.933 0v-4h-1.4v4zm6.666-5.332v5.332h-1.4V6.665z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ChartBarFilledSize16Glyph.displayName = 'ChartBarFilledSize16Glyph';
